'use client';

import React from 'react';
import { useTranslation } from 'react-i18next';
import getDateBreakdown from '~/utils/getDateBreakdown';

export default function DurationDate({
  classNames,
  visibleParts,
  days,
}: {
  days: number;
  classNames: {
    value?: string;
    text?: string;
    wrapper?: string;
  };
  visibleParts?: {
    years?: boolean;
    months?: boolean;
    days?: boolean;
    weeks?: boolean;
  };
}) {
  const { t } = useTranslation('app');
  const dateBreakdown = getDateBreakdown(days);
  const yearsLabel = dateBreakdown.years === 1 ? t('year') : t('years');

  const monthsLabel = dateBreakdown.months === 1 ? t('mo') : t('mos');

  const weeksLabel = dateBreakdown.weeks === 1 ? t('week') : t('weeks');

  const daysLabel = dateBreakdown.days === 1 ? t('day') : t('days');

  const parts: React.ReactNode[] = [];

  if (visibleParts?.years && dateBreakdown.years > 0) {
    parts.push(
      <>
        <span className={classNames?.value}>{dateBreakdown.years}</span>
        <span className={classNames?.text}>{yearsLabel}</span>
      </>,
    );
  }

  if (visibleParts?.months && dateBreakdown.months > 0) {
    parts.push(
      <>
        <span className={classNames?.value}>{dateBreakdown.months}</span>
        <span className={classNames?.text}>{monthsLabel}</span>
      </>,
    );
  }

  if (visibleParts?.days && dateBreakdown.days > 0) {
    parts.push(
      <>
        <span className={classNames?.value}>{dateBreakdown.days}</span>
        <span className={classNames?.text}>{daysLabel}</span>
      </>,
    );
  }

  if (visibleParts?.weeks && dateBreakdown.weeks > 0) {
    parts.push(
      <>
        <span className={classNames?.value}>{dateBreakdown.weeks}</span>
        <span className={classNames?.text}>{weeksLabel}</span>
      </>,
    );
  }

  return (
    <div className="flex gap-0.5x">
      {parts.map((part, index) => (
        <React.Fragment key={index}>
          {index > 0 && <span className={classNames?.text}>{t('and')}</span>}
          {part}
        </React.Fragment>
      ))}
    </div>
  );
}
